export default __webpack_public_path__ + "static/Curve-94cdd795135527c4e2a9fc64a6cce895.png";